import { useState } from 'react'

function Element({ initialTime, onChange, ...props }) {
  const formatTime = (value) => {
    if (!value || value === 'undefined') return `00:00`

    let formattedTime = value.replace(/[^0-9]/g, '') // 숫자 이외의 문자 제거

    if (formattedTime.length > 4) {
      formattedTime = formattedTime.slice(0, 4) // 최대 4자리까지만 유지
    }

    const hours = formattedTime.substr(0, 2)
    const minutes = formattedTime.substr(2, 2)

    return `${hours}:${minutes}`
  }

  const getNewValue = (prevValue, newValue) => {
    if (newValue === prevValue || !isValid(newValue)) {
      return ''
    }

    if (newValue.length === 2 && prevValue.length !== 3 && !newValue.includes(':')) {
      newValue = `${newValue}:`
    }

    if (newValue.length === 2 && prevValue.length === 3) {
      newValue = newValue.slice(0, 1)
    }

    return newValue
  }

  const getNewValueOnBlur = (value) => {
    const inputValue = value
    const regex = /:/g
    const colonCount = inputValue.match(regex)?.length
    const isLastCharacterColon = regex.test(inputValue.slice(-1))
    const colonIndex = inputValue.indexOf(':')
    let updatedValue = '00:00'

    if (inputValue.length === 0) {
      updatedValue = '00:00'
    } else if (inputValue.length === 1) {
      // console.log("1 digit");
      if (colonCount !== 1) {
        updatedValue = '0' + inputValue + ':00'
      } else {
        updatedValue = '00:00'
      }
    } else if (inputValue.length === 2) {
      // console.log("2 digits");
      if (isLastCharacterColon) {
        updatedValue = '0' + inputValue + '00'
      } else {
        const splittedValue = inputValue.split(':')
        updatedValue = '00:0' + splittedValue[1]
      }
    } else if (inputValue.length === 3) {
      // console.log("3 digits");
      if (colonIndex === 2) {
        updatedValue = inputValue + '00'
      } else if (colonIndex === 1) {
        const splittedValue = inputValue.split(':')
        updatedValue = '0' + splittedValue[0] + ':0' + splittedValue[1]
      } else {
        updatedValue = '00' + inputValue
      }
    } else if (inputValue.length === 4) {
      // console.log("4 digits");
      if (colonIndex === 1) {
        updatedValue = '0' + inputValue
      } else {
        updatedValue = inputValue + '0'
      }
    } else {
      // console.log("5 digits");
      updatedValue = inputValue
    }

    return updatedValue
  }

  const [value, setValue] = useState(formatTime(initialTime))

  const handleBlur = (event) => {
    const updatedValue = getNewValueOnBlur(value)
    setValue(updatedValue)
    if (onChange) {
      onChange(updatedValue)
    }
  }

  const handleChange = (event) => {
    let newValue = ''
    if (event.target.value !== '') {
      newValue = getNewValue(value, event.target.value)
    }

    setValue(newValue)

    if (onChange) {
      onChange(event)
    }
  }

  const regexp = /^\d{0,2}?:?\d{0,2}$/u

  const isValidMinute = (minute) => {
    return Number.isInteger(minute) && minute >= 0 && minute < 60
  }

  const isValidHour = (hour) => {
    return Number.isInteger(hour) && hour >= 0 && hour < 24
  }

  const isValid = (value) => {
    if (!regexp.test(value)) {
      return false
    }

    const parts = value.split(':')
    const hourString = parts[0] ?? ''
    const minuteString = parts[1] ?? ''
    const hours = parseInt(hourString) || 0
    const minutes = parseInt(minuteString) || 0

    if (!isValidHour(hours) || !isValidMinute(minutes)) {
      return false
    }

    if (minutes < 10 && Number(minuteString[0]) > 5) {
      return false
    }

    return true
  }

  return (
    <div className={'input-text-wrap'}>
      <input
        {...props}
        onBlur={handleBlur}
        onFocus={(e) => e.target.select()}
        onChange={handleChange}
        type="text"
        value={value}
        className="input-text"
      />
    </div>
  )
}

export default Element
